import { Button, Grid, IconButton, Tooltip } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SelectField from './fields/SelectField'
import CurrencyTextField from '@unicef/material-ui-currency-textfield'

function SelectList({ selectItems, priceLabel, extraDataKey, extraDataDefaultValue, extraDataParseFunction, valueKey, onChange, label }) {
  const { t } = useTranslation()

  const [itemsList, setItemsList] = useState([null])

  const setExtraData = (extraData, index) => {
    setItemsList(itemsList.map((item, idx) => index === idx ? item === null ? {
      [valueKey]: null,
      [extraDataKey]: extraData
    } : { ...item, [extraDataKey]: extraData } : item))
  }

  const updateValues = (value, index) => {
    setItemsList(itemsList.map((item, idx) => index === idx ? item === null ? {
      [valueKey]: value,
      [extraDataKey]: extraDataKey ? extraDataDefaultValue : undefined
    } : { ...item, [valueKey]: value } : item))
  }

  const removeItem = index => {
    setItemsList(itemsList.filter((_, idx) => idx !== index))
  }

  const expandItemsList = () => {
    if (!itemsList.some(item => item === null))
      setItemsList(itemsList.concat(null))
  }

  useEffect(() => {
    onChange(itemsList)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsList])

  const renderItem = (item, index) => {
    return (
      <Grid container spacing={2}>

        <Grid item xs={7}>
          <SelectField
            label={label}
            id={index.toString()}
            items={selectItems}
            value={item === null || !item[valueKey] ? '' : itemsList[index][valueKey]}
            onChange={e => updateValues(e.target.value, index)}
          />
        </Grid>
        {
          extraDataKey &&
          <Grid item xs={3}>
            <CurrencyTextField
              light
              variant='filled'
              label={priceLabel || t('modals.plans.monthlyPrice')}
              currencySymbol="R$"
              outputFormat="number"
              decimalCharacter=","
              digitGroupSeparator="."
              value={item === null ? 0 : itemsList[index][extraDataKey]}
              onChange={(e, v) => setExtraData(extraDataParseFunction ? extraDataParseFunction(v) : v, index)}
              style={{ width: '100%' }} />
          </Grid>
        }
        {
          index !== 0 &&
          <Grid item xs={2}>
            <Tooltip title={t('default.removeItemFromList')}>
              <IconButton onClick={() => removeItem(index)}>
                <Close />
              </IconButton>
            </Tooltip>
          </Grid>
        }
      </Grid>
    )
  }

  return (
    <Grid container spacing={2}>
      {
        itemsList.map((entry, index) => (
          <Grid key={index} item xs={12}>
            {renderItem(entry, index)}
          </Grid>))
      }
      <Grid item xs={4}>
        <Button onClick={expandItemsList} style={{ width: '100%', backgroundColor: '#ddd', color: 'black' }}>
          {t('modals.plans.expandEntryList')}
        </Button>
      </Grid>
    </Grid>
  )
}

export default SelectList